import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { inventoryService } from '../../services/inventoryService';
import './InventorySnapshotPage.css';

const InventorySnapshotPage = () => {
  const navigate = useNavigate();
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [message, setMessage] = useState('');
  const [rebuilding, setRebuilding] = useState(false);

  const loadSnapshot = async () => {
    setLoading(true);
    const result = await inventoryService.getSnapshot();
    if (result.success) {
      setItems(result.items || []);
      setError('');
    } else {
      setError(result.error);
    }
    setLoading(false);
  };

  useEffect(() => {
    loadSnapshot();
  }, []);

  const handleRebuild = async () => {
    setRebuilding(true);
    setMessage('');
    setError('');
    const rebuild = await inventoryService.rebuildSnapshot();
    if (!rebuild.success) {
      setError(rebuild.error);
      setRebuilding(false);
      return;
    }
    setMessage(rebuild.data?.message || 'Snapshot rebuilt.');
    await loadSnapshot();
    setRebuilding(false);
  };

  return (
    <div className="inventory-page">
      <header className="inventory-header">
        <div className="inventory-header-content">
          <div>
            <h1>Inventory Snapshot</h1>
            <p>Money, tickets, and unique shows by user/vendor</p>
          </div>
          <div className="inventory-actions">
            <button className="btn btn-secondary" onClick={() => navigate('/dashboard')}>
              Back to Dashboard
            </button>
            <button className="btn btn-primary" onClick={handleRebuild} disabled={rebuilding}>
              {rebuilding ? 'Rebuilding...' : 'Rebuild Snapshot'}
            </button>
          </div>
        </div>
      </header>

      <main className="inventory-main">
        {error && <div className="notification error">{error}</div>}
        {message && <div className="notification success">{message}</div>}
        {loading ? (
          <div className="loading-container">
            <div className="loading-spinner"></div>
            <p>Loading snapshot...</p>
          </div>
        ) : (
          <div className="inventory-table-wrap">
            <table className="inventory-table">
              <thead>
                <tr>
                  <th>User</th>
                  <th>Inv_Dice</th>
                  <th>Inv_Aspen</th>
                  <th>Inv_Tao</th>
                  <th>Inv_GetIn</th>
                  <th>Inv_AXS</th>
                  <th>Inv_Seetickets</th>
                  <th>Inv_Tixr</th>
                  <th>Inv_Pacha</th>
                  <th>Inv_Ticketmaster</th>
                  <th>Tickets_Dice</th>
                  <th>Tickets_Aspen</th>
                  <th>Tickets_Tao</th>
                  <th>Tickets_GetIn</th>
                  <th>Tickets_AXS</th>
                  <th>Tickets_Seetickets</th>
                  <th>Tickets_Tixr</th>
                  <th>Tickets_Pacha</th>
                  <th>Tickets_Ticketmaster</th>
                  <th>Shows_Dice</th>
                  <th>Shows_Aspen</th>
                  <th>Shows_Tao</th>
                  <th>Shows_GetIn</th>
                  <th>Shows_AXS</th>
                  <th>Shows_Seetickets</th>
                  <th>Shows_Tixr</th>
                  <th>Shows_Pacha</th>
                  <th>Shows_Ticketmaster</th>
                </tr>
              </thead>
              <tbody>
                {items.map((row) => (
                  <tr key={row.user_id}>
                    <td>{row.username}</td>
                    <td>{Number(row.Inv_Dice || 0).toFixed(2)}</td>
                    <td>{Number(row.Inv_Aspen || 0).toFixed(2)}</td>
                    <td>{Number(row.Inv_Tao || 0).toFixed(2)}</td>
                    <td>{Number(row.Inv_GetIn || 0).toFixed(2)}</td>
                    <td>{Number(row.Inv_AXS || 0).toFixed(2)}</td>
                    <td>{Number(row.Inv_Seetickets || 0).toFixed(2)}</td>
                    <td>{Number(row.Inv_Tixr || 0).toFixed(2)}</td>
                    <td>{Number(row.Inv_Pacha || 0).toFixed(2)}</td>
                    <td>{Number(row.Inv_Ticketmaster || 0).toFixed(2)}</td>
                    <td>{row.Tickets_Dice || 0}</td>
                    <td>{row.Tickets_Aspen || 0}</td>
                    <td>{row.Tickets_Tao || 0}</td>
                    <td>{row.Tickets_GetIn || 0}</td>
                    <td>{row.Tickets_AXS || 0}</td>
                    <td>{row.Tickets_Seetickets || 0}</td>
                    <td>{row.Tickets_Tixr || 0}</td>
                    <td>{row.Tickets_Pacha || 0}</td>
                    <td>{row.Tickets_Ticketmaster || 0}</td>
                    <td>{row.Shows_Dice || 0}</td>
                    <td>{row.Shows_Aspen || 0}</td>
                    <td>{row.Shows_Tao || 0}</td>
                    <td>{row.Shows_GetIn || 0}</td>
                    <td>{row.Shows_AXS || 0}</td>
                    <td>{row.Shows_Seetickets || 0}</td>
                    <td>{row.Shows_Tixr || 0}</td>
                    <td>{row.Shows_Pacha || 0}</td>
                    <td>{row.Shows_Ticketmaster || 0}</td>
                  </tr>
                ))}
              </tbody>
            </table>
            {items.length === 0 && <p className="empty-line">No inventory rows found.</p>}
          </div>
        )}
      </main>
    </div>
  );
};

export default InventorySnapshotPage;

